export function getMolGraph(dict, libKey) {
    return dict[libKey.polymerType]?.[libKey.symbol];
}
export function hasMolGraph(dict, libKey) {
    return !!dict[libKey.polymerType]?.[libKey.symbol];
}
export function setMolGraph(dict, libKey, value) {
    let pt = dict[libKey.polymerType];
    if (!pt)
        pt = dict[libKey.polymerType] = {};
    pt[libKey.symbol] = value;
}
/** Role of an entry in a HELM RNA splitted sequence.
 * SUGAR/BASE/PHOSPHATE are the standard triple positions.
 * TERMINAL_5P marks a 5'-end terminal modifier (e.g. Chol) — a monomer
 * with R2 only that takes the place of the leading sugar.
 * TERMINAL_3P marks a 3'-end terminal modifier (e.g. GalNAc) — a monomer
 * with R1 only that takes the place of the trailing phosphate. The OH cap
 * MUST be omitted when a TERMINAL_3P is present. */
export var NucleotideRole;
(function (NucleotideRole) {
    NucleotideRole[NucleotideRole["SUGAR"] = 0] = "SUGAR";
    NucleotideRole[NucleotideRole["BASE"] = 1] = "BASE";
    NucleotideRole[NucleotideRole["PHOSPHATE"] = 2] = "PHOSPHATE";
    NucleotideRole[NucleotideRole["TERMINAL_5P"] = 3] = "TERMINAL_5P";
    NucleotideRole[NucleotideRole["TERMINAL_3P"] = 4] = "TERMINAL_3P";
})(NucleotideRole || (NucleotideRole = {}));
export class MonomerMap extends Map {
    constructor(entries) {
        super(entries);
    }
}
/** @property monomers key - helm seq position, */
export class MolfileWithMap {
    constructor(molfile, monomers) {
        this.molfile = molfile;
        this.monomers = monomers;
    }
    static createEmpty() { return new MolfileWithMap('', new MonomerMap(null)); }
}
//# sourceMappingURL=types.js.map